import React from 'react';
import './Layouts.css'
import MainPage from '../Components/MainPage/MainPage';

export default function IndexLayout() {
    return (
        <div className='main-app'>
            <MainPage />
        </div>
    );
}
